import consentModeRegions from "web/script/analytics/consent-mode-regions";
import bingConversion from "web/script/embedded/bing-conversion";

export default {
    setDefaultConsentMode: function () {
        // Set consent mode default state
        // EEA + UK Region
        bingConversion("consent", "default", {
            ad_storage: "denied",
            region: consentModeRegions.EEA.concat(consentModeRegions.UK),
        });

        // USA Region
        bingConversion("consent", "default", {
            ad_storage: "granted",
            region: consentModeRegions.USA,
        });
    },

    updateConsentMode: function (cookiesState) {
        // Update Consent Mode
        var adStorageCookie =
            cookiesState.acceptsAds && cookiesState.acceptsPersonalizedAds ? "granted" : "denied";

        bingConversion("consent", "update", {
            ad_storage: adStorageCookie,
        });
    },
};
